// Copyright © 2021 Move Closer
import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { ThumbnailsList, Tile, TileSize } from '../../_components/ui';
import { InnerGridWrapper } from '../_partials';
import { ModuleAdditionalRows } from '../../_contracts';
import { TeaserBoxInnerGrid, TeaserBoxVersion } from '../TeaserBox.contracts';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let TeaserBoxInnerGrid6SThumbnailsList = class TeaserBoxInnerGrid6SThumbnailsList extends TeaserBoxInnerGrid {
    constructor() {
        super(...arguments);
        this.tileConfig = {
            isPremium: this.teaserBoxConfig.isPremium,
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            showAuthorAvatar: false,
            showAuthorName: false,
            showCategory: false,
            showPublicationDate: this.teaserBoxConfig.showPublicationDate,
            showTitle: true,
            size: TileSize.S,
            titleOnImage: true,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
        this.listConfig = {
            showArticleTags: this.teaserBoxConfig.showArticleTags,
            titleVersion: this.teaserBoxConfig.titleVersion
        };
    }
    get tilesOffset() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.addOne:
                return 9;
            case ModuleAdditionalRows.addTwo:
                return 12;
            default:
                return 6;
        }
    }
    get gridStyle() {
        switch (this.teaserBoxConfig.additionalRows) {
            case ModuleAdditionalRows.None:
                return 'teaser-box__list-wrapper';
            case ModuleAdditionalRows.addOne:
                return 'teaser-box__list-wrapper-three-rows';
            case ModuleAdditionalRows.addTwo:
                return 'teaser-box__list-wrapper-four-rows';
            default:
                return 'teaser-box__list-wrapper';
        }
    }
};
TeaserBoxInnerGrid6SThumbnailsList.moduleVersion = TeaserBoxVersion['6S-thumbnails-list'];
TeaserBoxInnerGrid6SThumbnailsList = __decorate([
    Component({
        name: 'TeaserBoxInnerGrid6SThumbnailsList',
        components: { InnerGridWrapper, ThumbnailsList, Tile },
        template: `
    <InnerGridWrapper>
      <template v-if="articles && articles.length">
        <!-- Tiles -->
        <Tile v-for="article in articles.slice(0, tilesOffset)" :key="article.id"
              v-bind="{ ...tileConfig, article, fallbackImage, windowService, isLazy, isMobile }" />

        <!-- ThumbnailsList -->
        <div :class="gridStyle">
          <ThumbnailsList v-bind="{ readMoreLink, fallbackImage, listConfig, windowService, isLazy, isMobile }" :articles="articles.slice(tilesOffset)" />
        </div>
      </template>
    </InnerGridWrapper>
  `
    })
], TeaserBoxInnerGrid6SThumbnailsList);
export { TeaserBoxInnerGrid6SThumbnailsList };
